import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth";
import { ErrorBanner } from "../components/ui";
import { BrandLockup } from "../components/BrandLockup";
import { privacyDoc as PrivacyDoc } from "../legal";

export function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  return (
    <div className="min-h-screen flex flex-col bg-tora-paper">
      {/* ブランドトップ strip (画像リファレンス準拠) */}
      <header className="bg-white border-b-2 border-tora-accent">
        <div className="mx-auto max-w-7xl px-4 py-3">
          <BrandLockup />
        </div>
      </header>

      <main className="flex-1 flex flex-col items-center justify-center px-4 py-10">
        <form
          className="card w-full max-w-md p-6 md:p-8 shadow-md"
          onSubmit={async (e) => {
            e.preventDefault();
            setErr(null);
            setBusy(true);
            try {
              await login(email, password);
              nav("/", { replace: true });
            } catch (e) {
              setErr((e as Error).message ?? "ログインに失敗しました");
            } finally {
              setBusy(false);
            }
          }}
        >
          <p className="text-[11px] text-tora tracking-widest font-semibold">
            MEMBER SIGN IN
          </p>
          <h1 className="text-2xl md:text-3xl font-bold text-tora-ink mt-1.5">
            会員ログイン
          </h1>
          <p className="text-sm text-tora-ink/70 mt-1 mb-6">
            登録メールアドレスとパスワードでログインしてください。
          </p>

          <div className="mb-4">
            <label className="label" htmlFor="email">
              メールアドレス
            </label>
            <input
              id="email"
              type="email"
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              autoCapitalize="off"
              autoCorrect="off"
              spellCheck={false}
              inputMode="email"
              autoFocus
              placeholder="例: yamada@example.com"
            />
          </div>
          <div className="mb-4">
            <label className="label" htmlFor="password">
              パスワード
            </label>
            <input
              id="password"
              type="password"
              className="input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={8}
              autoComplete="current-password"
            />
          </div>
          {err && (
            <ErrorBanner className="mb-3">
              <span className="block">{err}</span>
              {/* パスワード違いで止まった人が、そのまま再設定へ進めるようにする。
                  下部のリンクは見落とされやすいため、エラーの直下にも置く。 */}
              <Link
                to="/password-reset"
                className="tap-target mt-1 text-sm font-semibold underline"
              >
                パスワードを再設定する →
              </Link>
            </ErrorBanner>
          )}
          <button className="btn-primary btn-lg w-full" disabled={busy}>
            {busy ? "ログイン中…" : "ログイン →"}
          </button>
          <div className="mt-5 flex items-center justify-between">
            <Link
              to="/password-reset"
              className="tap-target text-sm text-tora hover:underline"
            >
              パスワードをお忘れの方
            </Link>
            <Link
              to="/register"
              className="tap-target text-sm text-tora hover:underline font-semibold"
            >
              新規会員登録 →
            </Link>
          </div>
        </form>
        {/* 規約・方針は登録前に読めるべきものなので、ここから開けるようにする。
           個人情報保護方針を持たないブランドではリンクを出さない */}
        <p className="mt-6 text-center text-xs text-tora-ink/50 flex items-center justify-center gap-3">
          <Link to="/terms" className="hover:text-tora hover:underline">利用規約</Link>
          {PrivacyDoc && (
            <Link to="/privacy" className="hover:text-tora hover:underline">個人情報保護方針</Link>
          )}
        </p>
      </main>
    </div>
  );
}
